<template>
    <div class="modal hide fade in" id="modalEnvio" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title label-black">Seleccione criterio de lista</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">    
                    <div class="row">
                        <div class="col-12">
                            <h6 class="label-black" v-if="ListaDePersonal.length > 0">Coincidencias encontradas: ({{ListaDePersonal.length}})</h6>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 table-responsive">
                            <table
                            class="table table-striped table-light table-hover" id="tablaPersonal">
                            <thead class="thead-custom">
                                <tr>
                                <th>Nombre</th>
                                <th>Puesto</th>
                                <th>Departamento</th>
                                <th>Área</th>
                                <th></th>
                                </tr>
                            </thead>
                            <tbody class="text-dark">
                                <tr v-for="infoPersona in ListaDePersonal" :key="infoPersona.PersonaId">
                                
                                <td>{{infoPersona.Nombre}} {{infoPersona.ApellidoPaterno}} {{infoPersona.ApellidoMaterno}}</td>
                                <td>{{infoPersona.Puesto }}</td>
                                <td>{{infoPersona.Departamento }}</td>
                                <td>{{infoPersona.Seccion }}</td>
                                <td class="d-flex justify-content-around">
                                    <i
                                    class="far fa-check-square"
                                    @click="ModalClose(infoPersona)"
                                    title="Seleccionar Servidor"
                                    />
                                </td>
                                </tr>
                            </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-custom" id="botonCancelar" >Cancelar</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:
    {
        ListaDePersonal: Array
    },
    methods:{
        Mostrar: function () {
            if (this.ListaDePersonal.length>5)
                {
                    this.$nextTick(() => {
                        PaginarTabla("tablaPersonal", 5);
                        });
                }
            $('#modalEnvio').modal('show');
            $('#botonCancelar').unbind('click').click(this.ModalClose);
            $('#closeModal').unbind('click').click(this.ModalClose);
            
            },
        ModalClose: function(info){
            $('#modalEnvio').modal('hide');
            //$('#modalSolicitud').modal('dispose');
            this.$emit('Resultado', {"Estatus":false, "Persona" : info});
        },
    },
    mounted(){
        this.Mostrar();
        
    }
}
</script>
<style scoped>
  .thead-custom {
  background-color: #004746;
  color: white;
}
.modal-content {
        background-color:  #7e7f74;
    }
    .modal-header {
        background-color:  #007573;
    }
    .label-black {
        color: black;
    }
    .btn-custom {
        background-color: #004746;
        color: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/SIAP/Incidencias/ModalLista.vue